export default "__VITE_PUBLIC_ASSET__042577c2__"